"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_SEARCH_BY_PUBLISHER_CRITERIA = void 0;
const mobx_1 = require("mobx");
const searchAPI = __importStar(require("@App/api/routes/search"));
const search_1 = require("@App/api/routes/search");
const calc_num_pages_1 = require("@App/helpers/pagination/calc-num-pages");
const check_is_empty_object_1 = require("@App/helpers/check-is-empty-object");
const get_num_titles_1 = require("@App/helpers/pagination/get-num-titles");
const search_criteria_store_1 = __importDefault(require("@App/stores/search/search-criteria-store"));
const search_option_type_1 = require("@App/enum/search-option-type");
const required_criteria_1 = require("@App/enum/required-criteria");
const uuid_1 = require("uuid");
const searchPublishersOptions = [
    { id: (0, uuid_1.v4)(), value: 'fullName', label: 'Publisher Name' },
    { id: (0, uuid_1.v4)(), value: 'ipiNameNumber', label: 'Publisher IPI' },
    { id: (0, uuid_1.v4)(), value: 'hfaNumber', label: 'MLC Publisher Number' },
];
exports.DEFAULT_SEARCH_BY_PUBLISHER_CRITERIA = [
    { id: searchPublishersOptions[0].id, selectedOption: searchPublishersOptions[0], searchTerm: '', isFixed: true },
];
class PublicSearchPublishersStore {
    createPublisherSearchCriteriaStore() {
        const publisherSearchMaxCriteria = 1;
        return new search_criteria_store_1.default(exports.DEFAULT_SEARCH_BY_PUBLISHER_CRITERIA, searchPublishersOptions, search_option_type_1.SearchOptionType.filter, required_criteria_1.RequiredCriteria.first, publisherSearchMaxCriteria);
    }
    constructor(rootStore) {
        Object.defineProperty(this, "rootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_publicSearchByPartySearchQuery", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_publicSearchByPublisherCriteriaPaginationInfo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_publicSearchByPartyWorksPaginationInfo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_searchResultPartyDetails", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_selectedWorks", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_showWorks", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_totalNumberOfResults", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_currentPublisherResultsPerPageLimit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_currentWorkResultsPerPageLimit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_currentSearchCriteriaStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "selectedPublisherDetails", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "displayType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'public'
        });
        (0, mobx_1.makeObservable)(this, {
            _searchResultPartyDetails: mobx_1.observable,
            _selectedWorks: mobx_1.observable,
            _showWorks: mobx_1.observable,
            _totalNumberOfResults: mobx_1.observable,
            _currentSearchCriteriaStore: mobx_1.observable,
            numTitles: mobx_1.computed,
            partyWorksNumTitles: mobx_1.computed,
            publisherSearch: mobx_1.computed,
            worksResultMessage: mobx_1.computed,
            setShowWorks: mobx_1.action,
            resetStore: mobx_1.action,
            resetWorks: mobx_1.action,
            resetPublishersAndWorks: mobx_1.action,
        });
        this.rootStore = rootStore;
        this.resetStore();
    }
    get searchResultPartyDetails() {
        return this._searchResultPartyDetails;
    }
    get searchCriteriaStore() {
        return this._currentSearchCriteriaStore;
    }
    get publicSearchByPartyCriteriaPaginationInfo() {
        return this._publicSearchByPublisherCriteriaPaginationInfo;
    }
    get publicSearchByPartyWorksPaginationInfo() {
        return this._publicSearchByPartyWorksPaginationInfo;
    }
    get currentPartyResultsPerPageLimit() {
        return this._currentPublisherResultsPerPageLimit;
    }
    get currentWorkResultsPerPageLimit() {
        return this._currentWorkResultsPerPageLimit;
    }
    get selectedWorks() {
        return this._selectedWorks;
    }
    get showWorks() {
        return this._showWorks;
    }
    get totalNumberOfResults() {
        return this._totalNumberOfResults;
    }
    get numTitles() {
        return (0, get_num_titles_1.getNumTitles)(this._searchResultPartyDetails.length, this._publicSearchByPublisherCriteriaPaginationInfo
            ? this._publicSearchByPublisherCriteriaPaginationInfo.currentPage
            : 1, this._currentPublisherResultsPerPageLimit);
    }
    get partyWorksNumTitles() {
        var _a, _b, _c, _d;
        return (0, get_num_titles_1.getNumTitles)((_b = (_a = this._selectedWorks) === null || _a === void 0 ? void 0 : _a.count) !== null && _b !== void 0 ? _b : 0, (_d = (_c = this._publicSearchByPartyWorksPaginationInfo) === null || _c === void 0 ? void 0 : _c.currentPage) !== null && _d !== void 0 ? _d : 1, this._currentWorkResultsPerPageLimit);
    }
    get publisherSearch() {
        return this._publicSearchByPartySearchQuery;
    }
    get worksResultMessage() {
        var _a, _b;
        if ((_a = this.selectedPublisherDetails) === null || _a === void 0 ? void 0 : _a.name) {
            return `Works for ${this.selectedPublisherDetails.name}`;
        }
        if ((_b = this.selectedPublisherDetails) === null || _b === void 0 ? void 0 : _b.ipiNumber) {
            return `Works for Publisher IPI: ${this.selectedPublisherDetails.ipiNumber}`;
        }
        return 'Works';
    }
    setCurrentResultsPerPageLimit(newLimit) {
        return __awaiter(this, void 0, void 0, function* () {
            this._currentPublisherResultsPerPageLimit = newLimit;
            yield this.searchForParties();
        });
    }
    setShowWorks(showWritersWorks) {
        this._showWorks = showWritersWorks;
    }
    setPublisherQuery(publisherQuery) {
        this._publicSearchByPartySearchQuery = publisherQuery;
    }
    searchForParties() {
        return __awaiter(this, arguments, void 0, function* (pagination = { page: 1, limit: this._currentPublisherResultsPerPageLimit }) {
            if (this.publisherSearch && !(0, check_is_empty_object_1.isEmptyObject)(this.publisherSearch)) {
                this.rootStore.preloaderStore.openTransparentPreloader(true);
                this.resetPublishersAndWorks();
                const publishers = yield this.searchForPartiesApiCall(pagination);
                (0, mobx_1.runInAction)(() => {
                    this._searchResultPartyDetails = publishers.results;
                });
                if (pagination.limit && pagination.page && publishers) {
                    (0, mobx_1.runInAction)(() => {
                        this._totalNumberOfResults = publishers.count;
                        this._publicSearchByPublisherCriteriaPaginationInfo = (0, calc_num_pages_1.calcNumPages)(publishers.count, pagination.limit, pagination.page);
                    });
                }
            }
            this.rootStore.preloaderStore.openTransparentPreloader(false);
        });
    }
    searchForPartiesApiCall(pagination) {
        return __awaiter(this, void 0, void 0, function* () {
            const results = yield (0, search_1.searchPublishers)(pagination, this.publisherSearch);
            const publishers = results.data;
            return {
                results: publishers.content.map((ip) => PublicSearchPublishersStore.convertInterestedPartyToPartyDetails(ip)),
                count: publishers.totalElements,
            };
        });
    }
    onChangeWorksPage(paginationBody) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.selectedPublisherDetails) {
                this.rootStore.preloaderStore.openTransparentPreloader(true);
                this.resetWorks();
                try {
                    const response = yield this.onChangeWorksPageApiCall(paginationBody);
                    (0, mobx_1.runInAction)(() => {
                        this._selectedWorks = response;
                        if (paginationBody.limit && paginationBody.page && response) {
                            this._publicSearchByPartyWorksPaginationInfo = (0, calc_num_pages_1.calcNumPages)(response.count, paginationBody.limit, paginationBody.page, paginationBody.refined);
                        }
                    });
                }
                catch (e) {
                    this.rootStore.popupStore.setAlertFromError(e);
                }
                this.rootStore.preloaderStore.openTransparentPreloader(false);
            }
        });
    }
    onChangeWorksPageApiCall(paginationBody) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            // TODO - refactor this mess when we remove old search
            const sortedPagination = Object.assign({ sort: [
                    { field: 'title.keyword', direction: 'asc' },
                    { field: 'property_id', direction: 'asc' },
                ] }, paginationBody);
            const pubIpId = ((_a = this.selectedPublisherDetails) === null || _a === void 0 ? void 0 : _a.ipId) ? Number((_b = this.selectedPublisherDetails) === null || _b === void 0 ? void 0 : _b.ipId) : 0;
            const apiResponse = yield searchAPI.searchWorksForPublisher(pubIpId, sortedPagination);
            return {
                count: apiResponse.data.totalElements,
                works: apiResponse.data.content,
            };
        });
    }
    searchForWorksByPublisherIpId(partyDetails) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (partyDetails.ipId !== ((_a = this.selectedPublisherDetails) === null || _a === void 0 ? void 0 : _a.ipId)) {
                this.selectedPublisherDetails = partyDetails;
                const pagination = { page: 1, limit: this._currentWorkResultsPerPageLimit };
                yield this.onChangeWorksPage(pagination);
            }
            (0, mobx_1.runInAction)(() => (this._showWorks = true));
        });
    }
    onChangeWorkResultsLimit(newLimit) {
        return __awaiter(this, void 0, void 0, function* () {
            this._currentWorkResultsPerPageLimit = newLimit;
            const pagination = { page: 1, limit: newLimit };
            yield this.onChangeWorksPage(pagination);
        });
    }
    resetStore() {
        this._currentPublisherResultsPerPageLimit = 10;
        this.resetPublishersAndWorks();
        this.resetSearchCriteriaStore();
        this._publicSearchByPartySearchQuery = {};
    }
    resetSearchCriteriaStore() {
        this._currentSearchCriteriaStore = this.createPublisherSearchCriteriaStore();
    }
    static convertInterestedPartyToPartyDetails(interestedParty) {
        return {
            ipId: '' + interestedParty.ipId,
            ipiNumber: interestedParty.ipiNumber,
            worksCount: interestedParty.worksCount,
            name: interestedParty.fullName,
            hfaPublisherNumber: interestedParty.hfaNumber,
        };
    }
    resetWorks() {
        this._selectedWorks = undefined;
        this._publicSearchByPartyWorksPaginationInfo = undefined;
    }
    resetPublishersAndWorks() {
        this._showWorks = false;
        this._searchResultPartyDetails = [];
        this._publicSearchByPublisherCriteriaPaginationInfo = undefined;
        this._totalNumberOfResults = 0;
        this.selectedPublisherDetails = { name: '', ipiNumber: '' };
        this._currentWorkResultsPerPageLimit = 10;
        this.resetWorks();
    }
}
exports.default = PublicSearchPublishersStore;
